import styled from '@emotion/styled';

export const SideBarLinkWrapperStyled = styled.div`
  display: flex;
  justify-content: space-between;
`;
